import React, { useState, useRef, useCallback } from 'react'
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api'

// Estilos para el contenedor del mapa (ancho completo y altura fija)
const containerStyle = {
  width: '100%',
  height: '600px',
}

// Centro inicial del mapa (latitud y longitud)
const center = {
  lat: 14.6,
  lng: -90.5,
}

 
const locations = [             
  // MÁQUINAS FARMABOX              
  { id: 2, lat: 14.572280410283035, lng: -90.48198474962031, name: 'V7_FARMABOX TORRE_TIGO', category: 'FARMABOX' },
  { id: 4, lat: 14.602682926139536, lng: -90.5136099039096, name: 'V8_FARMABOX FORUM_ZONA_VIVA', category: 'FARMABOX' },
  { id: 9, lat: 14.600210122929976, lng: -90.51216244232873, name: 'V1_FARMABOX FONTABELLA', category: 'FARMABOX' },
  { id: 10, lat: 14.600783253668675, lng: -90.51376284676243, name: 'V2_FARMABOX AVIA', category: 'FARMABOX' },
  { id: 11, lat: 14.607182108616945, lng: -90.50546597637954, name: 'V3_FARMABOX UFM', category: 'FARMABOX' },
  { id: 12, lat: 14.595439227733008, lng: -90.48375655619058, name: 'V4_FARMABOX URL', category: 'FARMABOX' },
  { id: 13, lat: 14.604507338297898, lng: -90.48963267640929, name: 'V6_FARMABOX UVG', category: 'FARMABOX' },
  { id: 14, lat: 14.512991356335068, lng: -90.45225556679227, name: 'V5_FARMABOX UNIS', category: 'FARMABOX' },
  { id: 21, lat: 14.598115218177803, lng: -90.51399957378236, name: 'V9_FARMABOX TORRE CITI GROUP', category: 'FARMABOX' },
  { id: 23, lat: 14.626184884870458, lng: -90.55585375275314, name: 'V10_FARMABOX PERI_ROOSEVELT', category: 'FARMABOX' },
  { id: 29, lat: 14.622427069423173, lng: -90.54936336676256, name: 'V11_FARMABOX RUS_MALL_ROOSEVELT', category: 'FARMABOX' },
  
  
  // MÁQUINAS GENBA           
  { id: 8, lat: 14.594746851407818, lng: -90.48329906638389, name: 'V1_GENBA_URL', category: 'GENBA' },
  { id: 18, lat: 14.60838855580391, lng: -90.4868673739113, name: 'V2_GENBA_CAYALA', category: 'GENBA' },
  { id: 19, lat: 14.604268135101591, lng: -90.48922223349217, name: 'V3_GENBA_UVG', category: 'GENBA' },
  { id: 20, lat: 14.512800594345842, lng: -90.45254993332782, name: 'V4_GENBA_UNIS', category: 'GENBA' },
  { id: 25, lat: 14.580047309289188, lng: -90.49451753498305, name: 'V1_GENBA_TELUS', category: 'GENBA' },
  { id: 38, lat: 14.607182108616945, lng: -90.50546597637954, name: 'V5_GENBA_UFM', category: 'GENBA' },

  // MÁQUINAS INJERTO
  { id: 17, lat: 14.613953070058589, lng: -90.48327406560848, name: 'V1_INJERTO PLAZA_VARIETA', category: 'INJERTO' },
  { id: 27, lat: 14.600210122929976, lng: -90.51216244232873, name: 'V2_INJERTO FONTABELLA', category: 'INJERTO' },
  { id: 28, lat: 14.58423328575629, lng: -90.5143436106799, name: 'V3_INJERTO PLAZA_DÉCIMA', category: 'INJERTO' },

  // MÁQUINAS MUMUSO
  { id: 22, lat: 14.58911803507393, lng: -90.51930503436584, name: 'V1_MUMUSO PARQUE_LAS_AMERICAS', category: 'MUMUSO' },

  // MÁQUINAS SUPER_24
  { id: 26, lat: 14.626419152331541, lng: -90.55530200542005, name: 'V1 SUPER_24 PERI_ROOSEVELT', category: 'SUPER 24' },
  { id: 33, lat: 14.599705328114647, lng: -90.51118097844338, name: 'V2 SUPER_24 HQ FONTABELLA', category: 'SUPER 24' },
  { id: 34, lat: 14.645920035014463, lng: -90.57858114147756, name: 'V3 SUPER_24 CASTAÑO', category: 'SUPER 24' },
  { id: 35, lat: 14.600210122929976, lng: -90.51216244232873, name: 'V4 SUPER_24 FONTABELLA', category: 'SUPER 24' },
  { id: 36, lat: 14.55296886299161, lng: -90.4544203552162, name: 'V5 SUPER_24 CONDADO CONCEPCION', category: 'SUPER 24' },
  { id: 37, lat: 14.607182108616945, lng: -90.50546597637954, name: 'V6 SUPER_24 UFM', category: 'SUPER 24' },


  // BEAUTY 
    { id: 32, lat: 14.8078112339893, lng: -89.53290416780112, name: 'V1 PUNTO BEAUTY PRADERA CHIQUIMULA', category: 'PUNTO BEAUTY' },



]
 //   
export const Map = () => {
  // Estado para guardar la categoría seleccionada en el filtro (por defecto 'TODOS')
  const [selectedCategory, setSelectedCategory] = useState('TODOS')

  // Hook para cargar la API de Google Maps, espera hasta que se cargue para renderizar el mapa
  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: 'AIzaSyCF7Ca3R2kuqIsgK5CQffikpHfJQS8qGqw',
  })

  // Referencia para guardar el objeto del mapa de Google, accesible en otras funciones si es necesario
  const mapRef = useRef(null)

  // Función que se ejecuta cuando el mapa se carga correctamente
  // Aquí se crea y añade un control personalizado (el filtro de categorías) directamente en el mapa
  const onLoad = useCallback((map) => {
    mapRef.current = map // Guardar referencia del mapa

    // Crear el contenedor del control (filtro)
    const controlDiv = document.createElement('div')
    controlDiv.style.margin = '10px'
    controlDiv.style.padding = '5px'
    controlDiv.style.backgroundColor = 'white'
    controlDiv.style.border = '2px solid #ccc' // Borde del contenedor
    controlDiv.style.borderRadius = '4px' // Bordes redondeados
    controlDiv.style.boxShadow = '0 2px 6px rgba(0,0,0,0.3)' // Sombra para dar profundidad

    // Crear el elemento <select> para el filtro de categorías
    const select = document.createElement('select')
    select.style.padding = '5px'
    select.style.fontSize = '14px'

    // Quitar borde del contenedor y del select para estilizar sin borde
    controlDiv.style.border = 'none'
    select.style.border = 'none'
    select.style.outline = 'none' // Quitar borde azul/negro al enfocar el select

    // Opciones disponibles para el filtro
    const options = ['TODOS', 'FARMABOX', 'GENBA', 'INJERTO', 'MUMUSO', 'SUPER 24', 'PUNTO BEAUTY']
    options.forEach(opt => {
      const option = document.createElement('option')
      option.value = opt
      option.textContent = opt
      select.appendChild(option)
    })

    // Poner el valor actual de la categoría seleccionada en el filtro
    select.value = selectedCategory

    // Escuchar cambios en el filtro para actualizar el estado de categoría seleccionada
    select.addEventListener('change', (e) => {
      setSelectedCategory(e.target.value)
    })

    // Agregar el select dentro del contenedor y luego el contenedor al control del mapa en la esquina superior izquierda
    controlDiv.appendChild(select)
    map.controls[window.google.maps.ControlPosition.TOP_LEFT].push(controlDiv)
  }, [selectedCategory])

  // Función que se ejecuta al hacer click en un marcador del mapa
  // Abre una nueva pestaña con la ubicación en Google Maps
  const handleMarkerClick = (location) => {
    const url = `https://www.google.com/maps?q=${location.lat},${location.lng}`
    window.open(url, '_blank')
  }

  // Filtra las ubicaciones según la categoría seleccionada
  const filteredLocations = selectedCategory === 'TODOS'
    ? locations
    : locations.filter(loc => loc.category === selectedCategory)

  // Mostrar mensaje de carga mientras se carga la API de Google Maps
  if (!isLoaded) return <p>Cargando mapa...</p>

  return (
    <div id="map" style={{ padding: '60px 0', backgroundColor: '#f9f9f9' }}>
      <div className="container">
        <h2 className="text-center"> </h2>


<div style={{ textAlign: 'center', marginBottom: '2px' }}>
<div className="section-title" style={{ textAlign: 'center', marginBottom: '2px' }}>
  <h2>¡Visualiza en qué zonas ya estamos presentes!</h2>
  <p style={{ color: '#cc5500' }}></p>
</div>



  <p style={{ color: '#cc5500' }}>
    
  </p>
</div>


        {/* Contenedor para el mapa */}
        <div className="map-wrapper" style={{ marginTop: '30px' }}>
          <GoogleMap
            mapContainerStyle={containerStyle} // Aplicar tamaño al mapa
            center={center} // Centro inicial del mapa
            zoom={12} // Nivel de zoom
            onLoad={onLoad} // Llamada a función cuando el mapa se carga (para agregar filtro)
          >
            {/* Renderiza los marcadores en el mapa filtrados por categoría */}
            {filteredLocations.map((loc) => (
              <Marker
                key={loc.id}
                position={{ lat: loc.lat, lng: loc.lng }} // Coordenadas del marcador
                title={loc.name} // Texto al pasar el mouse
                onClick={() => handleMarkerClick(loc)} // Acción al hacer click
              />
            ))}
          </GoogleMap>
        </div>
      </div>
    </div>
  )
}
